// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__16J6L","select":"Header_select__2Hovr","clinic":"Header_clinic__2fwUg"};